import { render, staticRenderFns } from "./StrategyManage.vue?vue&type=template&id=617ef323&scoped=true&"
import script from "./StrategyManage.vue?vue&type=script&lang=ts&"
export * from "./StrategyManage.vue?vue&type=script&lang=ts&"
import style0 from "./StrategyManage.vue?vue&type=style&index=0&id=617ef323&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617ef323",
  null
  
)

export default component.exports